// extracted by mini-css-extract-plugin
export default {"container":"total-price_container__TATpY","price":"total-price_price__M1gb3","price__icon":"total-price_price__icon__cJhw+"};